<template>
    <div class="table-cell-wrapper_content / flex">
        <VJoyBadge bulletpoint :variant="statusVariant" :label="t(`projectclient.purchaseorderlist.table.status.${status}`).toLowerCase()" />
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyBadge} from '@maltjoy/core-vue';
    import {PurchaseOrderStatus} from '@api';

    const {t} = useTranslation();

    const props = defineProps<{
        status: PurchaseOrderStatus;
    }>();

    const statusVariant = computed(() => {
        switch (props.status) {
            case PurchaseOrderStatus.RemainingBudget:
                return 'info';
            case PurchaseOrderStatus.Cleared:
                return 'green';
            case PurchaseOrderStatus.EstimationOverrun:
                return 'yellow';
            case PurchaseOrderStatus.InvoicedOverrun:
                return 'red';
            default:
                return 'gray';
        }
    });
</script>

<style lang="scss" scoped>
    .table-cell-wrapper_content {
        flex-flow: row nowrap;
    }
</style>
